import * as React from 'react'
import { Carousel } from '@amzn/dvui/dist/Carousel'
import { ICollection } from '../../selectors/collections'
import { CarouselCollectionItem } from './carouselCollectionItem'
import * as cn from 'classnames'
import * as st from './carouselCollectionItem.module.scss'

interface CarouselState {
  isCarouselFocused: boolean
}

export class CarouselCollection extends React.PureComponent<ICollection, CarouselState> {
  state: CarouselState
  containerRef: React.RefObject<HTMLDivElement>

  constructor(props: ICollection) {
    super(props)
    this.state = {
      isCarouselFocused: false
    }
    this.containerRef = React.createRef()
  }

  setFocusedCarousel(index: number) {
    this.setState({
      isCarouselFocused: index === this.props.index
    })
  }

  resetFocusedCarousel() {
    this.setState({ isCarouselFocused: false })
  }

  componentDidUpdate() {
    // If the carousel contains the focused element, but
    // another has more recently been interacted with, clear
    // the focus, to close the hover (if it's open)
    if (!this.state.isCarouselFocused) {
      const activeElement = document.activeElement as HTMLElement
      const currentContainer = this.containerRef && this.containerRef.current
      if (currentContainer && activeElement && currentContainer.contains(activeElement))
        activeElement.blur()
    }
  }

  render (){
    const { header, cardTitleIds, refTagPrefix, totalEpisodeSize, index } = this.props

    if (cardTitleIds.length === 0) {
      return null
    }

    return (
      <div
        className={cn(`dv-hover-packshot-container ${st.collection}`, {
          [st.singleItemCarousel]: totalEpisodeSize === 1
        })}
        ref={this.containerRef}>
        {header && <h1 className={st.title}> {header} </h1>}
          <Carousel
            className={cn(st.carouselWrapper, {
              [st.focusedCarousel]: this.state.isCarouselFocused
            })}
            leftScrollButtonClassName={st.scrollButton}
            rightScrollButtonClassName={st.scrollButton}>
            {cardTitleIds.map((titleId, idx) => (
              <CarouselCollectionItem
                key={`carousel-collection-${titleId}-${idx}`}
                idx={idx}
                titleId={titleId}
                refTagPrefix={refTagPrefix}
                requestFocusForCarousel={() => this.setFocusedCarousel(index)}
                resetFocusForCarousel={() => this.resetFocusedCarousel()}
              />
            ))}
          </Carousel>
      </div>
    )
  }
}